"use client"

import * as React from "react"
import { animate, scrambleText } from "animejs"
import { cn } from "cn"

import { useMotionScope } from "../../hooks/use-motion-scope"

type ScrambleCharset = "uppercase" | "lowercase" | "numbers" | "symbols" | "blocks" | "braille" | "shades"

function ScrambleText({
  text,
  charset = "uppercase",
  cursor = false,
  className,
  ...props
}: Omit<React.ComponentProps<"span">, "children"> & {
  text: string
  charset?: ScrambleCharset
  cursor?: boolean
}) {
  const { root } = useMotionScope<HTMLSpanElement>(
    ({ root, reduced }) => {
      if (reduced) {
        root.textContent = text
        return
      }
      animate(root, {
        innerHTML: scrambleText({ text, chars: charset, cursor }),
      })
    },
    [text, charset, cursor]
  )

  return (
    <span data-slot="scramble-text" className={cn(className)} {...props}>
      <span className="sr-only">{text}</span>
      <span ref={root} aria-hidden="true">
        {text}
      </span>
    </span>
  )
}

export { ScrambleText, type ScrambleCharset }
